import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isFunction } from "lodash";

import {
  updateMeterUploadRow,
  type RowInput,
} from "@services/bulkMeterUpload";

export const useUpdateMeterUploadRow = ({
  onSuccess,
  ...options
}: Record<string, any> = {}) => {
  const queryClient = useQueryClient();
  return useMutation(
    ({
      meterUploadId,
      rowId,
      input,
    }: {
      meterUploadId: string;
      rowId: string;
      input: RowInput;
    }) => updateMeterUploadRow(meterUploadId, rowId, input),
    {
      ...options,
      onSuccess: (row, vars) => {
        queryClient.invalidateQueries({
          queryKey: ["meterUpload", vars.meterUploadId],
        });
        if (isFunction(onSuccess)) onSuccess(row, vars);
      },
    },
  );
};
